import axios from 'axios';
import { isJsonString } from "utilities/common";
import { getData } from 'utilities/common';

// Create an instance of Axios with default configurations
const axiosClientDistribution = axios.create({
  baseURL: process.env.REACT_APP_DISTRIBUTION_API_BASE_URL, // Replace with your axiosClient base URL
  // baseURL: "https://r9723pzx-3067.inc1.devtunnels.ms",
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': 0
  }
});

// Request interceptor: Modify requests before they are sent
axiosClientDistribution.interceptors.request.use(
  (config) => {
    const user = getData('login-user-info')
    if (user) {
      const parseUser = JSON.parse(user)
      config.headers['Authorization'] = 'Bearer ' + parseUser?.access_token
    }
    if (config.method === "get") {
      config.url = config.url?.includes("?") ? `${config.url}&platform=hyperwolf` : `${config.url}?platform=hyperwolf`
    } else if ((config.method === "post" || config.method === "put") && config.headers['Content-Type'] === 'application/json') {
      let data = {}
      if (isJsonString(config.data)) {
        data = JSON.parse(config.data)
      } else if (typeof config.data === "object") {
        data = config.data
      }
      config.data = { ...data, platform: "hyperwolf" }
    }

    return config
  },
  (error) => {
    // Handle request errors here
    return Promise.reject(error);
  }
);

// Response interceptor: Modify responses before they are handled by the calling code
axiosClientDistribution.interceptors.response.use(
  (response) => {
    // Modify response data or perform actions before passing it to the calling code
    return response?.data;
  },
  (error) => {
    if (error?.response?.status === 401 || error?.response?.data?.message === 'Invalid token!') {
      window.location.href = "/login"
      localStorage.clear()
      return Promise.reject(error)
    }

    return Promise.reject(error)
  }
);

export default axiosClientDistribution;